import {
    HorizAlignment, ISearch, ISearchProfile, ISearchProvider,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_CubeSource_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_CUBESOURCE_ID:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CUBESOURCE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUBESOURCE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    PARAMETER1_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Parameter 1', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    PARAMETER2_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Parameter 2', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CLASS_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Class', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    MANUAL_IND:          {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Manual', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const CubeSourceSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_CUBESOURCE_ID',
                id_ui: 'CUBESOURCE_ID',
                name:  'CUBESOURCE_NAME'},

    searchProviderFields: vUI_CubeSource_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_CubeSource_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const CubeSourceSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "CubeSourceSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'CUBESOURCE_ID',   renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'CUBESOURCE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CUBESOURCE_NAME','CUBESOURCE_ID','PARAMETER1_NAME', 'MANUAL_IND', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CubeSourceSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const CubeSourceSearch: ISearch = {
    searchName: "Find CubeSource",
    renderOptions: { ui5ResourceId: "CubeSourceSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CubeSourceSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("CubeSourceBO", "CubeSource", CubeSourceSearch, "Cube Source Search")

export {CubeSourceSearch}
